module.exports = __webpack_public_path__ + "img/Flag_of_Greenland.a21731d5.svg";